import widget from './widget';
import settings from './settings';

export default {
  widget,
  settings,
  name: 'Pickup',
  description: 'Displays boxes waiting for pickup, and a button to clear the list'
};



// WEBPACK FOOTER //
// ./app/widgets.new/Pickup/index.js